module.exports = require("pdfjs-dist");